<template>
    <!-- <el-form :model="loginData" :rules="loginRules" ref="loginForm" label-position="left" label-width="0px" class="demo-ruleForm login-container"> -->
    <el-container class="loginPage" :style="{height:tableHeight,width:tableWidth}">
      <el-main>
        <div class="login-container">
          <div class="loginLeft">
            <div class="login_img">
              <transition-group name="flip-list" tag="ul">
                <li v-for="curImg in currImgs" v-bind:key="curImg" class="list-item">
                  <img :src="curImg" alt="" srcset="">
                </li>
              </transition-group>
            </div>
          </div>
          <el-form :model="loginData" ref="loginForm" label-position="left" label-width="0px" class="demo-ruleForm "
                   :rules="loginRules">
            <h1 class="title">账号登录</h1>
            <img :src="logonImg" alt="" class="logoImg">
            <el-form-item prop="username">
              <el-input type="text" v-model="loginData.username" auto-complete="off" placeholder="请输入账号"></el-input>
            </el-form-item>
            <el-form-item prop="password" style="margin-top:10%">
              <el-input type="password" v-model="loginData.password" auto-complete="off" placeholder="请输入密码"
                        @keyup.enter="startLogin('loginForm')"></el-input>
            </el-form-item>
            <div style="margin-top:39px"></div>
            <el-form-item style="width:100%;text-align:center">
              <el-button type="primary" style="width:100%;" @click="startLogin('loginForm')">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-main>
      <el-footer>
        <el-row type="flex" justify="center" align="middle">
          <a href="https:/beian.miit.gov.cn/" style="color: #FFFFFF" target="blank">沪ICP备17009955号-1</a>
        </el-row>
      </el-footer>
    </el-container>
</template>
<script>
import {getUserInfo, GetUserSysInfo} from "../api/api";
import md5 from "js-md5";
import VueCookies from "vue-cookies"

export default {
  data() {
    return {
      currImgs: [],
      imgs: [
        require('../assets/u459.jpg'),
        require('../assets/u457.jpg'),
      ],
      logonImg: require("../assets/logo01.png"),
      index: 0,
      isTrue: true,
      tableHeight: "",
      tableWidth: "",
      // logining: false,
      loginData: {
        username: "",
        password: ""
      },
      loginRules: {
        username: [
          {required: true, message: "请输入账号", trigger: "blur"}
        ],
        password: [
          {required: true, message: "请输入密码", trigger: "blur"}
        ]
      },
      checked: true
    };
  },
  mounted() {
    this.tableHeight = (window.innerHeight) + 'px';
    this.tableWidth = (window.innerWidth) + 'px';
    this.currImgs = [this.imgs[0]];
    this.startChange();
    window.addEventListener('keydown', this.keyDown)
  },
  methods: {
    //获取菜单列表
    getSysAdmin() {
      getUserInfo({})
          .then((res) => {
            if (res) {
              let sysUserName = res.staff_name;
              sessionStorage.setItem("sysUserName", JSON.stringify(res));

              let t = this.$cookies.get('access_token');
              if (t && t !== "") {
                this.$router.push({path: "/index"});

                sessionStorage.setItem("menuTabsValue", JSON.stringify(""));
                sessionStorage.setItem("menuTabs", JSON.stringify([]));
              }
            }
          })
          .catch((res) => {
            this.$message("查询用户名异常");
          });
    },
    //开始登陆
    keyDown(e) {
      if (e.keyCode === 13) {
        this.$nextTick(() => {
          this.startLogin('loginForm');
        });
      }
    },
    startLogin(form) {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.$axios.post("/login", this.loginData).then(res => {
            this.$cookies.set('access_token', res.headers.authorization);

            if (res.data.success == false) {
              this.$message.error(res.data.errorMsg)
              return false
            }
            this.getSysAdmin();

          }).catch(res => {
            this.$message('登录出错，请重试！')
          })
          //    this.$router.push({ path: "/index" });
        } else {
          this.$message('请输入账号密码')
          return false;
        }
      });

    },
    initUserInfo(token) {
      GetUserSysInfo({}).then((res) => {
        if (res.code == 0 && res.info) {
          localStorage.setItem("userid", res.info.userid);
          localStorage.setItem("userName", res.info.uname);
          localStorage.setItem("userpk", res.info.userpk);
          localStorage.setItem("usermappingpk", res.info.usermappingpk);
          localStorage.setItem("orgpk", res.info.orgpk);
          localStorage.setItem("orgtype", res.info.orgtype);
          localStorage.setItem("orgcode", res.info.orgcode);
          localStorage.setItem("cnname", res.info.cnname);
          localStorage.setItem("enname", res.info.enname);
          localStorage.setItem("menuList", JSON.stringify(res.info.menuList));
          localStorage.setItem("funcList", JSON.stringify(res.info.funcList));
          this.$router.push({path: "/"});
        } else {
          //location.href = "/html/login.html";
        }
      }).catch(res => {
        // location.href = "/html/login.html";
      });

    },
    startChange: function () {
      var _this = this;
      setInterval(function () {
        if (_this.index < _this.imgs.length - 1) {
          _this.index++
        } else {
          _this.index = 0
        }
        _this.currImgs.splice(0, 1, _this.imgs[_this.index]);
      }, 9000);
    },

  }
};
</script>

<style lang="scss">

.loginLeft {
  float: left;
}

.loginPage h1 {
  margin: 0;
  padding: 0;
}

.demo-ruleForm {
  float: left;
}

.login-container {
  position: relative;
  overflow: hidden;
  /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
  -webkit-border-radius: 5px;
  border-radius: 3px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  margin: 10% auto 0;
  width: 50%;
  height: 55%;
  padding: 1%;
  background: #fff;
  border: 1px solid #eaeaea;

  .logoImg {
    width: 9%;
    position: absolute;
    right: 5%;
    top: 5%;
  }

  .title {
    margin: 10% auto;
    text-align: center;
    font-weight: 700;
    font-style: normal;
    color: #085299;
    font-size: 24px;
  }

  button {
    width: 90% !important;
    height: 30%;
    color: #FFF;
    background-color: rgba(40, 122, 198, 1);
    margin-top: 10%;
    text-align: center;
  }

  .remember {
    margin: 0px 0px 35px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// LoginForm.vue?a6fc1952